import React, { useState, createContext } from 'react';
import { useNavigate } from 'react-router';

export const BreadcrumbsContext = createContext();

export const BreadcrumbsProvider = props => {
  const navigate = useNavigate();
  const [breadcrumbsItems, setBreadcrumbsItems] = useState([
    {
      key: '1',
      text: 'Home',
      pathname: '/',
      onClick: () => {
        navigate('/dashboard');
      },
    },
  ]);
  const [navSelected, setNavSelected] = useState('Home');
  const [breadcrumbsLoading, setBreadcrumbsLoading] = useState(false);
  const value = {
    navSelected,
    setNavSelected,
    breadcrumbsItems,
    setBreadcrumbsItems,
    breadcrumbsLoading,
    setBreadcrumbsLoading,
  };

  return <BreadcrumbsContext.Provider value={value}>{props.children}</BreadcrumbsContext.Provider>;
};
